import { Component, OnInit } from '@angular/core';
import { NavController } from 'ionic-angular';

import { BtLocalService } from '../../app/core/local-data-services/bt-local.service';
import { MeasureInputService } from '../../app/core/measure-input.service';
import { ObservationService } from '../../app/core/observation.service';
import { TabsService } from '../../app/core/tabs.service';
import { BT, Measure, MeasureContext } from '../../app/models/models';
import { BTInputPage } from '../bt/bt-input/bt-input';

@Component({
  selector: 'page-measure-input',
  templateUrl: 'measure-input.html'
})
export class MeasureInputPage implements OnInit {
  bt: BT;
  measure: Measure;
  measureContext: MeasureContext;

  constructor(private measureInputService: MeasureInputService,
              private navCtrl: NavController,
              private observationService: ObservationService,
              private tabsService: TabsService) {
  }

  ionViewWillEnter() {
    this.bt = BtLocalService.getBT();
    this.tabsService.updateTab1();
    if (!this.bt) {
      this.navCtrl.setRoot(BTInputPage);
    }
  }

  ngOnInit() {
    this.measure = MeasureInputService.getCurrentMeasure();
    this.measureContext = MeasureInputService.getMeasureContext();

    this.measureInputService.currentMeasureUpdated$.subscribe(
      (measure: Measure) => this.measure = measure || new Measure(this.bt)
    );
    this.measureInputService.measureContextUpdated$.subscribe(
      (measureContext: MeasureContext) => this.measureContext = measureContext || new MeasureContext()
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/measure-input/measure-input.ts